<template>
  <footer class="checkout-footer">
    <div class="checkout-footer__container">
      <div class="checkout-footer__copy">
        2022 Mental Future. All Rights Reserved.
      </div>
      <div class="checkout-footer__items white">
        <router-link to="#" class="checkout-footer__item">
          General Terms
        </router-link>
        <router-link to="#" class="checkout-footer__item">
          Privacy Policy
        </router-link>
        <router-link to="#" class="checkout-footer__item">
          Contact Us
        </router-link>
      </div>
      <div class="checkout-footer__social">
        <router-link to="#" class="checkout-footer__social-item">
          <svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M3.618 23.426h4.07V13.203h3.16l.52-4.062h-3.68V6.33c0-.625.086-1.116.346-1.429.26-.357.823-.535 1.602-.535h2.078V.749C10.934.659 9.895.57 8.684.57c-1.56 0-2.771.491-3.68 1.429-.953.937-1.386 2.232-1.386 3.928v3.214H.285v4.062h3.333v10.223z" fill="#fff"/></svg>
        </router-link>
        <router-link to="#" class="checkout-footer__social-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M10 4.866c.893 0 1.741.268 2.545.714a4.735 4.735 0 011.875 1.875c.446.804.714 1.652.714 2.545 0 .938-.268 1.786-.714 2.59a4.734 4.734 0 01-1.875 1.874 5.163 5.163 0 01-2.545.67 5.207 5.207 0 01-2.59-.67 4.735 4.735 0 01-1.874-1.875A5.207 5.207 0 014.866 10c0-.893.223-1.741.67-2.545A4.735 4.735 0 017.41 5.58c.803-.446 1.652-.714 2.589-.714zm0 8.482c.893 0 1.696-.312 2.366-.982A3.269 3.269 0 0013.348 10c0-.893-.357-1.696-.982-2.366-.67-.625-1.473-.982-2.366-.982-.938 0-1.741.357-2.366.982A3.239 3.239 0 006.652 10c0 .938.312 1.741.982 2.366.625.67 1.428.982 2.366.982zm6.563-8.705c0-.313-.134-.58-.358-.848-.267-.224-.535-.357-.848-.357-.357 0-.625.133-.848.357a1.116 1.116 0 00-.357.848c0 .357.09.625.357.848.223.268.491.357.848.357.313 0 .58-.09.804-.357.223-.223.357-.491.401-.848zm3.392 1.205c0 .848.045 2.232.045 4.152a82.42 82.42 0 01-.09 4.196 9.729 9.729 0 01-.356 2.188 5.29 5.29 0 01-1.25 1.964c-.536.536-1.206.938-1.92 1.206-.625.223-1.384.357-2.232.401C13.304 20 11.92 20 10 20c-1.964 0-3.348 0-4.196-.045-.849-.044-1.563-.178-2.188-.446a4.607 4.607 0 01-1.964-1.16c-.536-.537-.938-1.206-1.206-1.965-.223-.625-.357-1.34-.401-2.188C0 13.348 0 11.964 0 10c0-1.92 0-3.304.045-4.152C.089 5 .223 4.241.446 3.616c.268-.714.67-1.384 1.206-1.92A5.289 5.289 0 013.616.446 9.727 9.727 0 015.804.09C6.652.045 8.036 0 10 0c1.92 0 3.304.045 4.152.09.848.044 1.607.178 2.232.356a5.494 5.494 0 011.92 1.25 5.495 5.495 0 011.25 1.92c.178.625.312 1.384.401 2.232zm-2.142 10.045c.178-.491.267-1.295.357-2.41 0-.626.044-1.563.044-2.769V9.286c0-1.206-.044-2.143-.044-2.768-.09-1.116-.179-1.92-.358-2.41a3.385 3.385 0 00-1.92-1.92c-.49-.18-1.294-.268-2.41-.358-.67 0-1.607-.044-2.768-.044H9.286c-1.206 0-2.143.044-2.768.044-1.116.09-1.92.179-2.41.357-.938.358-1.563 1.027-1.92 1.92-.18.491-.313 1.295-.358 2.41-.044.67-.044 1.608-.044 2.769v1.428c0 1.206 0 2.143.044 2.768.045 1.116.179 1.92.357 2.41.358.938 1.027 1.563 1.92 1.92.491.18 1.295.313 2.41.358.626.044 1.563.044 2.769.044h1.428c1.206 0 2.143 0 2.768-.044 1.116-.045 1.92-.179 2.41-.358a3.385 3.385 0 001.92-1.92z" fill="#fff"/></svg>
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'CheckoutFooter',
}
</script>

<style lang="scss">
.checkout-footer {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  padding-bottom: 16px;

  &__copy {
    padding-right: 36px;
  }

  &__container {
    display: flex;
    align-items: center;
    max-width: 1316px;
    width: 100%;
    padding: 0 17px;
    margin-inline: auto;
  }

  &__items {
    display: flex;
    align-items: center;

    &.white {
      > * {
        color: #2f3542;
      }
    }
  }

  &__item {
    &:not(:last-child) {
      margin-right: 36px;
    }
  }

  &__social {
    display: flex;
    align-items: center;
    margin-left: auto;
  }

  &__social-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(#2f3542, 0.1);

    svg path {
      fill: #2f3542;
    }

    &:not(:last-child) {
      margin-right: 24px;
    }
  }
}
</style>
